module.exports = __webpack_public_path__ + "static/img/file.a23388f9.png";